import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import Format from '../utils/format';
import moment from 'moment';
import { v4 } from 'uuid';

class specialOfferStore {

    // Properties

    @observable specialOffers = [];
    @observable specialOfferId = 0;
    @observable taskId = 0;
    @observable taskName = '';

    @observable title = '';
    @observable titleEnglish = '';
    @observable titleChinese = '';
    @observable titleChineseTraditional = '';
    @observable titleThai = '';
    @observable titleJapanese = '';
    @observable titleArabic = '';

    @observable briefDesc = '';
    @observable briefDescEnglish = '';
    @observable briefDescChinese = '';
    @observable briefDescChineseTraditional = '';
    @observable briefDescThai = '';
    @observable briefDescJapanese = '';
    @observable briefDescArabic = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionArabic = '';

    @observable price = 0;
    @observable originalPrice = 0;

    @observable startDate = undefined;
    @observable startTime = undefined;

    @observable endDate = undefined;
    @observable endTime = undefined;

    @observable originalImageUrl = '';
    @observable imageUrl = '';
    @observable images = [];

    @observable sort = 1;

    @observable showBannerOnly = false;

    @observable lastChildItems = [];
    @observable lastChildItemFilter = [];

    @observable showUpdateSpecialOfferModal = undefined;
    @observable showSearchMenuItemModal = undefined;

    @observable itemSearchValue = '';

    @observable manageSpecialOfferTitle = '';

    @observable updateLoading = false;

    @action init() {
        this.setShowUpdateSpecialOfferModal(false);
        this.setShowSearchMenuItemModal(false);

        return ApiCaller.SpecialOffer.GetAll().then((specialOfferResponses) => {
            specialOfferResponses.map((item) => {
                item.startDate = Format.DateTime(item.startDate);
                item.endDate = Format.DateTime(item.endDate);

                return item;
            })

            this.specialOffers = specialOfferResponses;

            const languageCode = window.localStorage.getItem('lang') || 'en';
            ApiCaller.CmsTasks.getInRoomDiningAll(languageCode).then((fnbResponse) => {
                if (fnbResponse) {
                    if (fnbResponse.items.length > 0) {
                        this.lastChildItems = fnbResponse.items;
                        this.lastChildItemFilter = this.lastChildItems;
                    }
                }

                this.updateLoading = false;
            })
        })
    }

    @action initCreate() {
        this.manageSpecialOfferTitle = 'Add In Room Dining Offer';

        this.specialOfferId = 0;
        this.taskId = undefined;
        this.taskName = '';

        this.briefDesc = '';
        this.briefDescEnglish = '';
        this.briefDescChinese = '';
        this.briefDescChineseTraditional = '';
        this.briefDescThai = '';
        this.briefDescJapanese = '';

        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';

        this.title = '';
        this.titleEnglish = '';
        this.titleChinese = '';
        this.titleChineseTraditional = '';
        this.titleThai = '';
        this.titleJapanese = '';

        this.price = 0;
        this.originalPrice = 0;
        this.imageUrl = '';
        this.images = [{
            id: v4(),
            url: '',
            isLoading: false
        }];
        this.showBannerOnly = false;
        this.sort = 1;

        const today = moment();
        this.setStartDate(today);
        this.setStartTime(today);
        this.setEndDate(today);
        this.setEndTime(today);

        this.showUpdateSpecialOfferModal = true;
    }

    @action initUpdate(value) {
        this.specialOfferId = value;
        this.manageSpecialOfferTitle = 'Update In Room Dining Offer';

        return ApiCaller.SpecialOffer.GetById(this.specialOfferId).then((response) => {
            if (response) {
                this.specialOfferId = response.specialOfferId;
                this.taskId = response.taskId;
                this.taskName = response.taskName;

                this.title = response.title;
                this.briefDesc = response.briefDesc;
                this.description = response.description

                if (response.titleLang) {
                    this.titleEnglish = response.titleLang.english;
                    this.titleChinese = response.titleLang.chinese;
                    this.titleChineseTraditional = response.titleLang.chineseTraditional;
                    this.titleThai = response.titleLang.thai;
                    this.titleJapanese = response.titleLang.japanese;
                    this.titleArabic = response.titleLang.arabic || '';
                } else {
                    this.titleEnglish = this.title;
                    this.titleChinese = this.title;
                    this.titleChineseTraditional = this.title;
                    this.titleThai = this.title;
                    this.titleJapanese = this.title;
                    this.titleArabic = this.title;
                }

                if (response.briefDescLang) {
                    this.briefDescEnglish = response.briefDescLang.english;
                    this.briefDescChinese = response.briefDescLang.chinese;
                    this.briefDescChineseTraditional = response.briefDescLang.chineseTraditional;
                    this.briefDescThai = response.briefDescLang.thai;
                    this.briefDescJapanese = response.briefDescLang.japanese;
                    this.briefDescArabic = response.briefDescLang.arabic || '';
                } else {
                    this.briefDescEnglish = this.briefDesc;
                    this.briefDescChinese = this.briefDesc;
                    this.briefDescChineseTraditional = this.briefDesc;
                    this.briefDescThai = this.briefDesc;
                    this.briefDescJapanese = this.briefDesc;
                    this.briefDescArabic = this.briefDesc;
                }

                if (response.descriptionLang) {
                    this.descriptionEnglish = response.descriptionLang.english;
                    this.descriptionChinese = response.descriptionLang.chinese;
                    this.descriptionChineseTraditional = response.descriptionLang.chineseTraditional;
                    this.descriptionThai = response.descriptionLang.thai;
                    this.descriptionJapanese = response.descriptionLang.japanese;
                    this.descriptionArabic = response.descriptionLang.arabic || '';
                } else {
                    this.descriptionEnglish = this.description;
                    this.descriptionChinese = this.description;
                    this.descriptionChineseTraditional = this.description;
                    this.descriptionThai = this.description;
                    this.descriptionJapanese = this.description;
                    this.descriptionArabic = this.description;
                }

                this.price = response.price;
                this.originalPrice = response.originalPrice;

                const startDateTime = moment(response.startDate);
                this.setStartDate(startDateTime);
                this.setStartTime(startDateTime);

                const startEndTime = moment(response.endDate);
                this.setEndDate(startEndTime);
                this.setEndTime(startEndTime);

                this.imageUrl = response.imageUrl || '';

                this.images = [];
                if (response.imageUrl) {
                    try {
                        let imagesJson = JSON.parse(response.imageUrl);
                        imagesJson.map(imageJson => {
                            return imageJson.isLoading = false;
                        });
                        this.images = imagesJson;
                    } catch {
                        this.images.push({
                            id: v4(),
                            url: response.imageUrl,
                            isLoading: false
                        });
                    }
                }

                this.images.push({
                    id: v4(),
                    url: '',
                    isLoading: false
                });

                this.showBannerOnly = response.showBannerOnly;
                this.sort = response.sort;

                this.showUpdateSpecialOfferModal = true;
            }
        })
    }

    @action searchItemSelected(taskId) {
        const item = this.lastChildItems.find(x => x.taskId === taskId);
        if (item) {
            this.taskId = taskId;
            this.taskName = item.taskName;
            this.originalPrice = item.price;
            this.originalImageUrl = item.imageUrl;
            if (this.imageUrl === '') {
                this.imageUrl = this.originalImageUrl;

                this.images.push({
                    id: v4(),
                    url: this.imageUrl,
                    isLoading: false
                });
            }
        } else {
            this.taskId = 0;
            this.taskName = '';
            this.originalPrice = 0;
            this.originalImageUrl = '';
            if (this.imageUrl === '') {
                this.imageUrl = this.originalImageUrl;

                this.images.push({
                    id: v4(),
                    url: this.imageUrl,
                    isLoading: false
                });
            }
        }
    }

    @action searchItem() {
        this.lastChildItemFilter = this.lastChildItems.filter(item => {
            let itemTaskName = item.taskName.toLowerCase();
            return itemTaskName.indexOf(this.itemSearchValue.toLowerCase()) !== -1;
        });
    }

    @action createSpecialOffer() {
        this.updateLoading = true;
        const startTime = moment(this.startTime).format('HH:mm:00');
        const endTime = moment(this.endTime).format('HH:mm:00');
        const startDateTime = moment(`${moment(this.startDate).format('YYYY-MM-DD')} ${startTime}`);
        const endDateTime = moment(`${moment(this.endDate).format('YYYY-MM-DD')} ${endTime}`);
        this.imageUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

        return ApiCaller.SpecialOffer.apiCreateSpecialOffer(
            this.taskId,
            this.title, this.titleEnglish, this.titleChinese, this.titleChineseTraditional, this.titleThai, this.titleJapanese, this.titleArabic,
            this.price,
            this.briefDesc, this.briefDescEnglish, this.briefDescChinese, this.briefDescChineseTraditional, this.briefDescThai, this.briefDescJapanese, this.briefDescArabic,
            this.description, this.descriptionEnglish, this.descriptionChinese, this.descriptionChineseTraditional, this.descriptionThai, this.descriptionJapanese, this.descriptionArabic,
            startDateTime, endDateTime,
            this.imageUrl, this.showBannerOnly, this.sort).then(() => {
                this.init();
            });
    }

    @action updateSpecialOffer() {
        this.updateLoading = true;
        const startTime = moment(this.startTime).format('HH:mm:00');
        const endTime = moment(this.endTime).format('HH:mm:00');
        const startDateTime = moment(`${moment(this.startDate).format('YYYY-MM-DD')} ${startTime}`);
        const endDateTime = moment(`${moment(this.endDate).format('YYYY-MM-DD')} ${endTime}`);
        this.imageUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

        return ApiCaller.SpecialOffer.apiUpdateSpecialOffer(
            this.specialOfferId, this.taskId,
            this.title, this.titleEnglish, this.titleChinese, this.titleChineseTraditional, this.titleThai, this.titleJapanese, this.titleArabic,
            this.price,
            this.briefDesc, this.briefDescEnglish, this.briefDescChinese, this.briefDescChineseTraditional, this.briefDescThai, this.briefDescJapanese, this.briefDescArabic,
            this.description, this.descriptionEnglish, this.descriptionChinese, this.descriptionChineseTraditional, this.descriptionThai, this.descriptionJapanese, this.descriptionArabic,
            startDateTime, endDateTime,
            this.imageUrl, this.showBannerOnly, this.sort).then(() => {
                this.init();
            });
    }

    @action deleteSpecialOffer(specialOfferId) {
        return ApiCaller.SpecialOffer.Delete(specialOfferId).then(() => {
            this.init();
        });
    }

    // SET Properties

    @action setSpecialOfferId(value) {
        this.specialOfferId = value;
    }

    @action setBriefDesc(value) {
        this.briefDesc = value;
        this.briefDescEnglish = value;
    }

    @action setBriefDescChinese(value) {
        this.briefDescChinese = value
    }

    @action setBriefDescChineseTraditional(value) {
        this.briefDescChineseTraditional = value
    }

    @action setBriefDescThai(value) {
        this.briefDescThai = value;
    }

    @action setBriefDescJapanese(value) {
        this.briefDescJapanese = value;
    }

    @action setBriefDescArabic(value) {
        this.briefDescArabic = value;
    }

    @action setTitle(value) {
        this.title = value;
        this.titleEnglish = value;
    }

    @action setTitleChinese(value) {
        this.titleChinese = value;
    }

    @action setTitleChineseTraditional(value) {
        this.titleChineseTraditional = value;
    }

    @action setTitleThai(value) {
        this.titleThai = value;
    }

    @action setTitleJapanese(value) {
        this.titleJapanese = value;
    }

    @action setTitleArabic(value) {
        this.titleArabic = value;
    }

    @action setDescription(value) {
        this.description = value;
        this.descriptionEnglish = value;
    }

    @action setDescriptionChinese(value) {
        this.descriptionChinese = value;
    }

    @action setDescriptionChineseTraditional(value) {
        this.descriptionChineseTraditional = value;
    }

    @action setDescriptionThai(value) {
        this.descriptionThai = value;
    }

    @action setDescriptionJapanese(value) {
        this.descriptionJapanese = value;
    }

    @action setDescriptionArabic(value) {
        this.descriptionArabic = value;
    }

    @action setItemSearchValue(value) {
        this.itemSearchValue = value;
    }

    @action setShowUpdateSpecialOfferModal(value) {
        this.showUpdateSpecialOfferModal = value;
    }

    @action setShowSearchMenuItemModal(value) {
        this.showSearchMenuItemModal = value;
    }

    @action setPrice(value) {
        this.price = value;
    }

    @action setOriginalPrice(value) {
        this.originalPrice = value;
    }

    @action setStartDate(value) {
        this.startDate = value;
    }

    @action setStartTime(value) {
        this.startTime = value;
    }

    @action setEndDate(value) {
        this.endDate = value;
    }

    @action setEndTime(value) {
        this.endTime = value;
    }

    @action setImageUrl(value) {
        this.imageUrl = value;
    }

    @action setImageUrlAsOriginalImageUrl() {
        this.imageUrl = this.originalImageUrl;
    }

    @action setShowBannerOnly(value) {
        this.showBannerOnly = value;
    }

    @action setsort(value) {
        this.sort = value;
    }

    @action setImageUrlById(id, value) {
        let image = this.images.find(fi => fi.id === id);
        if (image) {
            image.url = value;
        }

        let blankImage = this.images.find(fi => fi.url === '');
        if (!blankImage) {
            this.images.push({
                id: v4(),
                url: '',
                isLoading: false
            });
        }
    }

    @action setImageIsLoadingById(id, isLoading) {
        let image = this.images.find(fi => fi.id === id);
        if (image) {
            image.isLoading = isLoading;
        }
    }

    @action removeImageById(id) {
        this.images = this.images.filter(fi => fi.id !== id);
    }
}

export default new specialOfferStore()